import { IReactor } from "../interfaces/reactor.interface";

export class Reactor implements IReactor {
  reactorName: string;
  bedNumber: number;

  constructor(object: IReactor) {
    Object.keys(object).map(key => this[key] = object[key]);
  }
}